// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { MessageProcessorBase } from './MessageProcessorBase';
export class BrokerMessageResponseCaseMessageProcessor extends MessageProcessorBase {
    decode(fieldSet) {
        return [];
    }
}
